<template></template>

<script>
import store from "@/lib/store";
import { callEndedNotification } from "./notifications";

export default {
  props: ["channel"],
  data() {
    return {
      user: store.get("user"),
    };
  },
  created() {
    this.channel.bind("connection.closed", ({ participant }) => {
      if (participant.userId === this.user.id) {
        callEndedNotification().show();
        this.showLiveMeetings();
      }
    });
  },
  methods: {
    showLiveMeetings() {
      this.$router.push({ path: "/live-coach" });
    },
  },
};
</script>



// WEBPACK FOOTER //
// connection-closed.vue?37bb7659